import React from "react"
import { Box, Tab, Tabs } from "@mui/material"
import i18n from "i18n"
import MyTemplatesTab from "./MyTemplatesTab"
import PlanhopperTemplatesTab from "./PlanhopperTemplatesTab"
import useTemplatesManager from "hooks/templates/useTemplatesManager"

const tabConfig = [
  {
    label: i18n.t("templates.myTemplates"),
    component: MyTemplatesTab,
  },
  {
    label: i18n.t("templates.defaultTemplates"),
    component: PlanhopperTemplatesTab,
  },
]

const TemplateList = () => {
  const { state, setTabSelected } = useTemplatesManager()

  const handleChange = (_e, newValue) => {
    setTabSelected(newValue)
  }
  const SelectedTabComponent = tabConfig[state.tabSelected].component
  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, padding: 1, borderColor: "divider" }}>
        <Tabs
          value={state.tabSelected}
          onChange={handleChange}
          aria-label="template tabs"
        >
          {tabConfig.map((t, index) => (
            <Tab key={index} label={t.label} />
          ))}
        </Tabs>
      </Box>
      <Box sx={{ padding: 2 }}>
        <SelectedTabComponent />
      </Box>
    </Box>
  )
}

export default TemplateList
